import { isViewVisible } from "../utils/ViewSettings";

export default () => {
  let links_map = {
    transactions: {
      url: "/finances/transactions",
      icon: "fi fi-dollar",
      isAccessible: isViewVisible("transactions", "finances"),
    },
    salesBillings: {
      url: "/finances/sales_billings",
      icon: "fi fi-list",
      isAccessible: isViewVisible("salesBillings", "finances"),
    } /*
        payment_accounts: {
            url: '/finances/payment_accounts',
            icon: 'fi fi-credit-card',
            isAccessible: isViewVisible('paymentAccounts','finances')
        }*/,
  };

  return links_map;
};
